<template>
    <article class="relative overflow-hidden">
        <div class="py-1 px-6 flex flex-col items-center space-y-6 sm:space-y-8">
            <cUtilsEdit
                v-if="testimonial.rate && !wall.hideStars"
                @edit="goToTestimonialField(testimonial.id, 'testimonialRate')"
            >
                <StarsMd :color="wall.starsColor" :rate="testimonial.rate" />
            </cUtilsEdit>

            <cUtilsEdit @edit="goToTestimonialField(testimonial.id, 'testimonialContent')">
                <div
                    :style="{
                        color: wall.textColor,
                    }"
                    class="w-full text-center text-sm sm:text-xl"
                >
                    <div class="ct-markdown" v-html="testContent" />
                </div>
            </cUtilsEdit>

            <cUtilsEdit
                v-if="allImages.length"
                @edit="goToTestimonialField(testimonial.id, 'testimonialMedia')"
            >
                <div class="h-14 lg:h-28">
                    <CardsInlineSliderMdWithPreview :images="allImages" />
                </div>
            </cUtilsEdit>

            <CardVideo
                v-if="testimonial.type === 'video' && testimonial.video"
                :src="testimonial.video"
            />

            <div class="flex flex-col items-center space-y-3 text-center">
                <cUtilsEdit
                    v-if="!wall.hideAvatar && showAvatar"
                    @edit="goToTestimonialField(testimonial.id, 'testimonialPhoto')"
                >
                    <AvatarMd
                        :image="testimonial.photo"
                        :name="testimonial.name"
                        :borderColor="wall.borderColor"
                        :textColor="wall.textColor"
                        :icon="avatarIcon"
                    />
                </cUtilsEdit>
                <cUtilsEdit @edit="goToTestimonialField(testimonial.id, 'testimonialName')">
                    <div class="space-y-0.5">
                        <p
                            :style="{
                                color: wall.textColor,
                            }"
                            class="text-sm font-medium"
                        >
                            {{ testimonial.name }}
                        </p>
                        <p
                            v-if="
                                !wall.hidePositionAndWww &&
                                (testimonial.position || testimonial.www)
                            "
                            class="text-xs opacity-80"
                            :style="{
                                color: wall.textColor,
                            }"
                        >
                            <span>{{ testimonial.position.trim() }}</span>
                            <span v-if="testimonial.position && testimonial.www"> · </span>
                            <a
                                v-if="testimonial.www"
                                class="text-sm"
                                :href="`http://${testimonial.www}`"
                                target="_blank"
                            >
                                <span class="truncate">{{ testimonial.www }}</span>
                            </a>
                        </p>
                    </div>
                </cUtilsEdit>
            </div>
        </div>
    </article>
</template>

<script>
import { markRaw } from "vue";
import { mapState } from "vuex";

import { CardsInlineSliderMdWithPreview, CardVideo } from "@easy/ui/cards";
import { StarsMd } from "@easy/ui/stars";
import { AvatarMd } from "@easy/ui/avatars";
import { VerifiedTickIcon, VerifiedGoogleIcon } from "@easy/ui/icons";
import { richTextModel } from "@easy/ui/forms";

import { useLoveGoTo } from "@/views/tools/love/utils/useLoveGoTo";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";

const MEDIA_TYPE = {
    video: "video",
    image: "image",
};

export default {
    name: "ReviewBig",
    props: {
        wall: Object,
        testimonial: Object,
    },
    setup() {
        const { goToTestimonialField } = useLoveGoTo();
        return { goToTestimonialField };
    },
    data() {
        return {
            selected: 1,
        };
    },
    components: {
        StarsMd,
        CardVideo,
        CardsInlineSliderMdWithPreview,
        AvatarMd,
        cUtilsEdit,
    },
    computed: {
        ...mapState(["imgUrl"]),
        allImages() {
            const videoFormats = /\.(mp4|avi|mov|wmv|flv|mkv)$/i;

            return [...this.testimonial.images, ...this.testimonial.gifs].map((x) => ({
                src: x,
                type: videoFormats.test(x) ? MEDIA_TYPE.video : MEDIA_TYPE.image,
            }));
        },
        testimonialPhoto() {
            return this.testimonial.photo &&
                (this.testimonial.photo.startsWith("http") ||
                    this.testimonial.photo.startsWith("https"))
                ? this.testimonial.photo
                : this.testimonial.photo
                  ? this.imgUrl + this.testimonial.photo
                  : null;
        },
        testContent() {
            return richTextModel.parseTestimonialToHTMLFromMarkdown(this.testimonial.content);
            /*return parseCode(
                escapeHtml(this.testimonial.content),
                !isColorDark(this.wall.textColor)
            );*/
        },
        avatarIcon() {
            return this.testimonial.source === "google"
                ? markRaw(VerifiedGoogleIcon)
                : this.testimonial.confirmed
                  ? markRaw(VerifiedTickIcon)
                  : {};
        },
        showAvatar() {
            return (
                this.testimonial.photo ||
                this.testimonial.confirmed ||
                this.testimonial.source === "google"
            );
        },
    },
};
</script>
